import { default as indexrkF6FeJFo9Meta } from "/app/pages/[area]/[country]/[city]/index.vue?macro=true";
import { default as index0Z7IoToUuBMeta } from "/app/pages/[area]/[country]/index.vue?macro=true";
import { default as indexf4EIMy8LotMeta } from "/app/pages/[area]/index.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as indexT2jspTj8yWMeta } from "/app/pages/radar/[area]/[country]/[city]/index.vue?macro=true";
import { default as indexHhsnHv72HWMeta } from "/app/pages/radar/[area]/[country]/index.vue?macro=true";
import { default as indexIUKC7KlM4aMeta } from "/app/pages/radar/[area]/index.vue?macro=true";
import { default as indexgE4LUaihW6Meta } from "/app/pages/radar/index.vue?macro=true";
export default [
  {
    name: "area-country-city",
    path: "/:area()/:country()/:city()",
    component: () => import("/app/pages/[area]/[country]/[city]/index.vue")
  },
  {
    name: "area-country",
    path: "/:area()/:country()",
    component: () => import("/app/pages/[area]/[country]/index.vue")
  },
  {
    name: "area",
    path: "/:area()",
    component: () => import("/app/pages/[area]/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "radar-area-country-city",
    path: "/radar/:area()/:country()/:city()",
    component: () => import("/app/pages/radar/[area]/[country]/[city]/index.vue")
  },
  {
    name: "radar-area-country",
    path: "/radar/:area()/:country()",
    component: () => import("/app/pages/radar/[area]/[country]/index.vue")
  },
  {
    name: "radar-area",
    path: "/radar/:area()",
    component: () => import("/app/pages/radar/[area]/index.vue")
  },
  {
    name: "radar",
    path: "/radar",
    component: () => import("/app/pages/radar/index.vue")
  }
]